export function shouldClearPortalStateForAuthSessionChange(
  previousUserId: string | null,
  nextUserId: string | null,
) {
  return previousUserId !== nextUserId;
}
